var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card-template-container" }, [
    _c("span", {
      class: [
        _vm.checkActionIconHelper(_vm.data.idActionType),
        "template-icon",
        "lf-icon__md",
      ],
    }),
    _c(
      "div",
      { staticClass: "info-container" },
      [
        _c("span", { staticClass: "ellipsis-text subject" }, [
          _vm._v(_vm._s(_vm.data.subject)),
        ]),
        _c("span", { staticClass: "responsible ellipsis-text" }, [
          _vm._v(_vm._s(_vm.data.responsible)),
        ]),
        _vm.data.description
          ? _c("span", { staticClass: "template-row ellipsis-text" }, [
              _vm._v(" " + _vm._s(_vm.data.description)),
            ])
          : _vm._e(),
        _c("div", { staticClass: "template-row ellipsis-text" }, [
          _c("span", { staticClass: "row-label" }, [
            _vm._v(_vm._s(_vm.$t("components.lexon_kanban.start_date")) + ":"),
          ]),
          _c("span", { staticClass: "row-value" }, [
            _vm._v(_vm._s(_vm.data.dateActionAt)),
          ]),
        ]),
        _vm._l(_vm.data.rows, function (row, index) {
          return _c("div", { key: index, staticClass: "template-row" }, [
            _c("span", { staticClass: "row-label" }, [
              _vm._v(_vm._s(row.label) + ":"),
            ]),
            _c("span", { staticClass: "row-value" }, [
              _vm._v(_vm._s(row.value)),
            ]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }